
export const LICENCE_KEY = "CH231637282";
export const LICENCE_KEY_MAPS = "MP257143429";
export const SERIES_TYPE_COLUMN = "SERIES_TYPE_COLUMN";
export const SERIES_TYPE_LINE = "SERIES_TYPE_LINE";
export const SERIES_TYPE_BUBBLE = "SERIES_TYPE_BUBBLE";

export const CATEGORY_TYPE_DATE = "CATEGORY_TYPE_DATE";
export const CATEGORY_TYPE_CATEGORY = "CATEGRY_TYPE_CATEGORY";

export const VALUE_AXIS_POSITION_RIGHT = "VALUE_AXIS_POSITION_RIGHT";
